module.exports = __webpack_public_path__ + "static/media/redsapp4.2c57a502.png";